module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-header is-medium bottom-align",
    class: {
      'is-center': !_vm.top, 'is-center-top': _vm.top
    },
    style: ({
      background: ("url(" + (this.backgroundImage) + ")")
    })
  }, [_c('div', {
    staticClass: "category container "
  }, [_c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "is-white m-b-5 title",
    class: _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet) ? 'is-2' : 'is-4'
  }, [_vm._v(_vm._s(_vm.content))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-051c3e5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/hero.vue
// module id = 1129
// module chunks = 1